import moment from 'moment'

export function PayrollDashboardService($http, apexApiUrl) {
    'ngInject'
    return {
        retrievePayrollCorporationsV2: retrievePayrollCorporationsV2,
        retrievePayrollCorporations: retrievePayrollCorporations,
        retrievePayrollCorporationsActive: retrievePayrollCorporationsActive,
        retrievePayrollRotations: retrievePayrollRotations,
        retrievePayrollRotationsV2: retrievePayrollRotationsV2,
        retrievePayrollDivisions: retrievePayrollDivisions,
        retrieveNCRSummary: retrieveNCRSummary,
        retrievePayChequeInquiryReports: retrievePayChequeInquiryReports,
        retrievePayrollOfficeDivision: retrievePayrollOfficeDivision
    };

    function retrievePayrollCorporationsV2(query) {
        return $http({
            method: "GET",
            url: apexApiUrl + "corporations",
            headers: { Accept: "application/json", "Content-Type": "application/json" },
            params: query || {}
        })
            .then(function (response) {
                return response.data;
            });
    }

    function retrievePayrollCorporations() {
        return $http({
            method: "GET",
            url: apexApiUrl + "payrolls/icd-corporation"
        })
            .then(function (response) {
                return response.data;
            });
    }

    function retrievePayrollCorporationsActive() {
        return $http({
            method: "GET",
            url: apexApiUrl + "payrolls/icd-corporation-active"
        })
            .then(function (response) {
                return response.data;
            });
    }

    function retrievePayrollRotations() {
        return $http({
            method: "GET",
            url: apexApiUrl + "payrolls/rotation"
        })
            .then(function (response) {
                return response.data;
            });
    }

    function retrievePayrollRotationsV2(divisionID, icdCorporationID) {
        const params = {
            divisionID, icdCorporationID
        }
        return $http({
            method: "GET",
            url: apexApiUrl + "payrolls/rotationV2",
            params: params
        })
            .then(function (response) {
                return response.data;
            });
    }

    function retrievePayrollDivisions() {
        return $http({
            method: "GET",
            url: apexApiUrl + "payrolls/divisions"
        })
            .then(function (response) {
                return response.data;
            });
    }

    function retrievePayrollOfficeDivision() {
        return $http({
            method: "GET",
            url: apexApiUrl + "payroll/icdofficedivision"
        }).then(function (response) {
            return response.data;
        });

    }
    function retrieveNCRSummary(payrollID, icdCorporationID, startDate, endDate) {
        const params = {
            payrollID,
            icdCorporationID,
            startDate: startDate ? moment(startDate).format("YYYY-MM-DD") : null,
            endDate: endDate ? moment(endDate).format("YYYY-MM-DD") : null
        }
        return $http({
            method: "GET",
            url: apexApiUrl + "ncr-summary",
            params: params
        })
            .then(function (response) {
                return response.data;
            });
    }

    function retrievePayChequeInquiryReports(startDate, endDate) {
        return $http({
            method: "GET",
            url: apexApiUrl + "payrolls/inquiry",
            headers: { Accept: "application/json" },
            params: {
                startDate: startDate,
                endDate: endDate
            }
        }).then(function (response) {
            return response.data;
        });
    }
}
